import { render, staticRenderFns } from "./ProjectSummaryPlaceholder.vue?vue&type=template&id=ab26dd74"
import script from "./ProjectSummaryPlaceholder.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports